// extracted by mini-css-extract-plugin
module.exports = {"tab":"styles_tab__gqr3G","active":"styles_active__LRibM","panel":"styles_panel__DEzOK","content":"styles_content__gHJnK","activeContent":"styles_activeContent__UHE6z"};